module.exports = __webpack_public_path__ + "assets/img/6.109b142b.png";